import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

export interface ConfirmDialogData {
  title?: string;
  message: string;
  icon?: string;
  accept?: string;
  reject?: string;
  acceptButtonStyleClass?: string;
  rejectButtonStyleClass?: string;
}

/**
 * Confirm Dialog Component - replacement for PrimeNG ConfirmDialog
 * Used through MatDialog service for confirmations
 */
@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  template: `
    <div class="confirm-dialog-container">
      <div class="confirm-dialog-header" *ngIf="data.title">
        <h2 class="confirm-dialog-title">{{ data.title }}</h2>
      </div>
      <div class="confirm-dialog-content">
        <p class="confirm-dialog-message">{{ data.message }}</p>
      </div>
      <div class="confirm-dialog-footer">
        <button
          mat-button
          [class]="data.rejectButtonStyleClass || 'btn-secondary'"
          (click)="onReject()"
        >
          {{ data.reject || 'Cancel' }}
        </button>
        <button
          mat-raised-button
          [class]="data.acceptButtonStyleClass || 'btn-primary'"
          (click)="onAccept()"
        >
          {{ data.accept || 'OK' }}
        </button>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .confirm-dialog-container {
        min-width: 300px;
        padding: 0;
      }

      .confirm-dialog-header {
        padding: 24px;
        border-bottom: 1px solid #e9eaec;
      }

      .confirm-dialog-title {
        margin: 0;
        font-size: 18px;
        font-weight: 700;
        color: #111827;
        font-family: 'Plus Jakarta Sans', sans-serif;
      }

      .confirm-dialog-content {
        padding: 24px;
      }

      .confirm-dialog-message {
        margin: 0;
        font-size: 14px;
        line-height: 1.5;
        color: #555963;
        font-family: 'Inter', sans-serif;
      }

      .confirm-dialog-footer {
        display: flex;
        justify-content: flex-end;
        gap: 12px;
        padding: 24px;
        border-top: 1px solid #e9eaec;
      }

      button {
        border-radius: 8px;
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-weight: 600;
        min-width: 100px;
      }
    `,
  ],
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  onAccept(): void {
    this.dialogRef.close(true);
  }

  onReject(): void {
    this.dialogRef.close(false);
  }
}
